// Added By : bhautik
// Created At: 28-5-2024
// Description: login slice
// Ticket ID: 001
import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {
  getAllPermission,
  getAllPermissionDetails,
} from "../../Api/services/permissionService";

const permissionSlice = createSlice({
  name: "permission",
  initialState: {
    roleData: [],
    permissionData: [],
    error: null,
    loading: false,
  },
  extraReducers: (builder) => {
    //get permission list
    builder
      .addCase(getAllPermission.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getAllPermission.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        }
        return {
          ...state,
          roleData: action.payload,
          loading: false,
        };
      })
      .addCase(getAllPermission.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //get permission options data
    builder
      .addCase(getAllPermissionDetails.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getAllPermissionDetails.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        }
        return {
          ...state,
          permissionData: action.payload,
          loading: false,
        };
      })
      .addCase(getAllPermissionDetails.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
  },
});

export default permissionSlice.reducer;
